module.exports = __webpack_public_path__ + "media/images/room_monitor/dry_stop-59647cae971d71f4e5ea041416c62788.png";